// Visual form of a call participant's label: bold contact name first, company in
// muted brackets — "**Contact Name** (Company)". Shared by the incoming-call and
// outbound-automation banners so both read the same.
export function PartyLabel({
  contactName,
  company,
  fallback = 'Unknown lead',
}: {
  contactName: string | null
  company: string
  fallback?: string
}) {
  const primary = contactName || company || fallback
  const showCompany = !!contactName && !!company
  return (
    <>
      <span className="font-semibold">{primary}</span>
      {showCompany && <span className="text-muted-foreground font-normal"> ({company})</span>}
    </>
  )
}
